<template>
    <transition name="modal">
        <b-modal id="talent-picker" v-bind:class="{ 'talent-selected': selectedTalent != ''}" ref="talent-picker" :size="size" no-close-on-esc no-close-on-backdrop>
            <div slot="modal-title" class="text-center">
                <h2 class="mb-0">Pick A Talent</h2>
            </div>                

            <div class="talent-picker-wrapper" id="talent-wrapper">

                <section class="section choose-language" v-if="screen === 1">
                    <b-row>
                        <b-col sm="12">
                            <div class="section-header">
                                <h2 class="text-center">Choose Language</h2>
                            </div>
                            <div class="section-body text-center">
                                <b-button block v-for="language in languages" class="green mb-2" @click="selectLanguage(2, language)" v-bind:key="language.id">{{language.name}}</b-button>
                            </div>
                        </b-col>
                    </b-row>
                
                </section>

                <section id="choose-talent" class="section choose-talent" v-if="screen === 2"> 
                    <b-row>
                        <b-col sm="12">
                            <talent-card v-for="talent in talents" :talent="talent" :key="talent.uuid" v-on:TalentPicked="closeModal"></talent-card>
                        </b-col>
                    </b-row>
                </section>

                <b-col v-bind:class="{ 'col-md-6': selectedTalent != '', 'col-md-12': selectedTalent == ''}" id="choose-talent" class="section choose-talent " v-if="false && screen === 2">
                    <b-row>
                        <b-col sm="6">
                            <h4>Male</h4>
                            <b-button block v-for="(talent, index) in males" v-bind:class="{active: talent.id == selectedTalent.id}" class="green" @click="selectTalent(3, talent)" v-bind:key="index">{{talent.name}}</b-button>
                            <div class="no-talents" v-if="males.length == 0">
                                <p>No talents with this language</p>
                            </div>
                        </b-col>
                        <b-col sm="6">
                            <h4>Female</h4>
                            <b-button block v-for="(talent, index) in females" v-bind:class="{active: talent.id == selectedTalent.id}" class="green" @click="selectTalent(3, talent)" v-bind:key="index">{{talent.name}}</b-button>
                            <div class="no-talents" v-if="females.length == 0">
                                <p>No talents with this language</p>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <section class="section play-samples" v-if="selectedTalent !== ''">
                    <b-row>
                        <b-col sm="12">
                            <transition-group name="samples" tag="div">
                                <h4 class="text-center" :key="selectedTalent.id+'-title'">{{selectedTalent.name}}'s Samples</h4>
                                <b-row :key="selectedTalent.id+'-samples'">
                                    <b-col sm="12">
                                        <div class="sample" v-for="sample in samples" v-bind:key="sample.id">
                                            <audio-player 
                                                :url="sample.path" 
                                                :index="sample.uuid" 
                                                :name="sample.name"
                                                v-on:playing="playing"
                                                :base_url="baseUrl"
                                            ></audio-player>
                                        </div>
                                    </b-col>
                                </b-row>
                            </transition-group>
                        </b-col>
                    </b-row>
                </section>
            </div>

            <div slot="modal-footer">
                <p class="text-center">Don't see a Talent you're looking for? Click <span class="link" @click="openChat">here</span>.</p>
            </div>
        </b-modal>
    </transition>
</template>

<script>      
    import AudioPlayer from '../AudioPlayer'
    import TalentCard from '../TalentCard'
    import {mapGetters} from 'vuex'
    export default {
        components: { TalentCard, AudioPlayer },
        props: ['applicationType'],
        data() {
            return {
                records: [],
                
                selectedLanguage: '',
                selectedTalent: '',
                screen: 1,
                playerPlaying: null,

                baseUrl: 'https://' + process.env.PROMPTS_URL + '/samples',

                size: 'lg'
            }
        },
        methods: {
            playing: function(playerId, sample_id) {
                this.playerPlaying = playerId;
            },
            goToSlide: function(next) {
                this.screen = this.screen + next;
                if(next == -1) {
                    this.selectedTalent = '';
                    this.size = 'md'
                }
            },
            selectLanguage: function(slide, language) {
                this.selectedLanguage = language;
                this.screen = slide;
            },
            selectTalent: function(slide, talent) {
                this.selectedTalent = talent;    
                this.size = 'lg'            
            },
            closeModal: function(talent) {
                this.$store.commit('project/setTalent', talent)
                this.$bvModal.hide('talent-picker')
                this.$emit('TalentPicked')
            },
            openChat: function() {
                if (window.LiveChatWidget) {
                    LiveChatWidget.call('maximize')
                }
            }
        },
        computed: {
            ...mapGetters({
                applications: 'tag/applications'
            }),
            
            males: function() {
                return this.talents.filter(function(talent) {
                    return talent.gender === 'male';
                });
            },
            females: function() {
                return this.talents.filter(function(talent) {
                    return talent.gender === 'female';
                });
            },
            talents: function() {
                if(this.selectedLanguage == '') {
                    return this.records;
                }
                var talents = [];
                var selectedLanguage = this.selectedLanguage;
                this.records.filter(function(talent) {
                   for(var i = 0; i < talent.samples.length; i++) {
                       var found = talent.samples[i].tags.filter(function(tag) { 
                           return tag.id == selectedLanguage.id;
                       });

                       if(found.length > 0) {
                           talents.push(talent);
                           break;
                       }
                   }
                });
                return talents;
            },
            languages: function() {
                var languages = [];
                for(var i = 0; i < this.records.length; i++) {
                    for(var j = 0; j < this.records[i].samples.length; j++) {
                        for(var k = 0; k < this.records[i].samples[j].tags.length; k++) {
                            var found = languages.filter((language) => {
                                return language.id == this.records[i].samples[j].tags[k].id;
                            });

                            if(found.length == 0 && this.records[i].samples[j].tags[k].parent == 1) {
                                languages.push(this.records[i].samples[j].tags[k]);
                            }
                        }

                    }
                }
                return languages;
            },
            showNext: function() {
                return ( this.screen != 3 && this.selectedLanguage != '' && this.selectedTalent != '' );
            },
            samples () {
                if (this.selectedTalent === '') {
                    return []
                }

                return this.selectedTalent.samples.filter(sample => {
                    let tags = sample.tags.filter(tag => tag.id === this.applicationType.id)
                    return tags.length
                });
            }
        },
        async created() {
            try {
                const res = await this.$store.dispatch('talent/fetch')
                if (res.data) {
                    console.log(res.data)
                    this.records = res.data
                }

                if (this.languages.length == 1) {
                    this.selectLanguage(2, this.languages[0])
                }
            } catch (ex) {
                console.log(ex)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// prompts/components/modals/TalentPicker.vue